import React, { useEffect, useState, useCallback, useRef } from "react";
import { useTranslation } from "ceco-polyglot";
import { Header } from "../../components/cecoadmin-panel";
import FullWidthLayout from "../../layout/FullWidthLayout";
import { AlertsTable } from "../../components/tables/AlertsTable";
import CreateButton from "../../components/CreateButton";
import { Dimmer, Loader } from "semantic-ui-react";
import graphql from "babel-plugin-relay/macro";
import { createPaginationContainer } from "react-relay";

const AlertsPage = (props) => {
  const {
    sidebarExpanded,
    setSidebarExpanded,
    setSidebarProps,
    menuExpanded,
    setMenuExpanded,
    allCategories,
    allWarnings,
    relay,
    children,
    ...rest
  } = props;
  const [search, setSearch] = useState();
  const { totalCount, edges } = allWarnings.allWarnings;
  const [isLoading, setIsLoading] = useState(false);
  const loadSearch = useRef(false);

  const alertsParsed = edges.map((alert, i) => {
    return {
      ...alert.node,
    };
  });

  const t = useTranslation();
  useEffect(() => {
    document.title = `Recetario Mambo - ${t("title.alerts")}`;
  }, [t]);

  const _loadMore = () => {
    if (!relay.hasMore() || relay.isLoading()) {
      return;
    }
    setIsLoading(true);
    relay.loadMore(20, () => {
      setIsLoading(false);
    });
  };

  const _refetch = () => {
    setIsLoading(true);

    relay.refetchConnection(
      search === "" || search === undefined ? 20 : null,
      () => setIsLoading(false),
      {
        slugName: search === "" || search === undefined ? null : search,
      }
    );
  };

  const handleScroll = (e) => {
    const target = e.target;
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      _loadMore();
    }
  };

  const onSearchText = useCallback(
    (txt) => {
      setSearch(txt);
    },
    [setSearch]
  );

  useEffect(() => {
    if (loadSearch.current) {
      setIsLoading(true);

      relay.refetchConnection(
        search === "" || search === undefined ? 20 : null,
        () => setIsLoading(false),
        {
          slugName: search === "" || search === undefined ? null : search,
        }
      );
    }
    loadSearch.current = true;
  }, [relay, search]);

  return (
    <FullWidthLayout>
      <Header
        title={t("title.alerts")}
        menuExpanded={menuExpanded}
        setMenuExpanded={setMenuExpanded}
        onSearchTextChange={onSearchText}
      >
        <CreateButton allCategories={allCategories} refetchData={_refetch} />
      </Header>
      <div className="table-wrapper">
        <>
          <AlertsTable
            alertsParsed={alertsParsed}
            totalCount={totalCount}
            _refetch={_refetch}
            handleScroll={handleScroll}
            {...rest}
          />
          {isLoading && (
            <Dimmer inverted active>
              <Loader indeterminate />
            </Dimmer>
          )}
        </>
      </div>
    </FullWidthLayout>
  );
};

export default createPaginationContainer(
  AlertsPage,
  {
    allWarnings: graphql`
      fragment AlertsPage_allWarnings on Query
      @argumentDefinitions(
        slugName: { type: "String" }
        count: { type: "Int", defaultValue: 20 }
        cursor: { type: "String" }
      ) {
        allWarnings(slugName: $slugName, first: $count, after: $cursor)
          @connection(key: "Alerts_allWarnings") {
          totalCount
          edges {
            node {
              id
              slugName
              description
              icon
            }
          }
        }
      }
    `,
  },
  {
    direction: "forward",
    getConnectionFromProps(props) {
      return props.allWarnings && props.allWarnings.allWarnings;
    },

    getFragmentVariables(prevVars, totalCount) {
      return {
        ...prevVars,
        count: totalCount,
      };
    },
    getVariables(props, { count, cursor }, fragmentVariables) {
      return {
        count,
        cursor,
      };
    },
    query: graphql`
      query AlertsPagePaginationQuery(
        $count: Int
        $cursor: String
        $slugName: String
      ) {
        ...AlertsPage_allWarnings
          @arguments(count: $count, cursor: $cursor, slugName: $slugName)
      }
    `,
  }
);
